import { render, staticRenderFns } from "./transport-vehicle-info-groups.vue?vue&type=template&id=3b2fb248&"
import script from "./transport-vehicle-info-groups.vue?vue&type=script&lang=js&"
export * from "./transport-vehicle-info-groups.vue?vue&type=script&lang=js&"
import style0 from "./transport-vehicle-info-groups.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports